import { render, staticRenderFns } from "./Shedule.vue?vue&type=template&id=60b00f3b&scoped=true&"
import script from "./Shedule.vue?vue&type=script&lang=js&"
export * from "./Shedule.vue?vue&type=script&lang=js&"
import style0 from "./Shedule.vue?vue&type=style&index=0&id=60b00f3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b00f3b",
  null
  
)

export default component.exports